var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verification-container" }, [
    _c("div", { staticClass: "verification-title-container" }, [
      _c("div", { staticClass: "title-text" }, [
        _vm._v(_vm._s(_vm.$t("userManage.AccountDataVerificationResult"))),
      ]),
      _c("div", { staticStyle: { "font-size": "14px" } }, [
        _vm._v(
          _vm._s(_vm.$t("userManage.TheSystemHasCompletedParsingExcelData"))
        ),
      ]),
    ]),
    _c(
      "div",
      { staticStyle: { padding: "20px" } },
      [
        _c(
          "el-row",
          { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "import-total" }, [
                _c("div", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v(_vm._s(_vm.$t("userManage.TotalImports"))),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      "font-weight": "bold",
                      color: "#000",
                    },
                  },
                  [_vm._v(_vm._s(_vm.validateData.totalCount))]
                ),
              ]),
            ]),
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "import-total" }, [
                _c("div", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v(_vm._s(_vm.$t("userManage.VerificationPassed"))),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      "font-weight": "bold",
                      color: "#0ca040",
                    },
                  },
                  [_vm._v(_vm._s(_vm.validateData.validCount))]
                ),
              ]),
            ]),
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "import-total" }, [
                _c("div", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v(_vm._s(_vm.$t("userManage.VerificationFailed"))),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      "font-weight": "bold",
                      color: "#dc2626",
                    },
                  },
                  [_vm._v(_vm._s(_vm.validateData.invalidCount))]
                ),
              ]),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "result-container" }, [
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", "margin-right": "5px" } },
            [_vm._v(_vm._s(_vm.$t("userManage.VerificationResult")) + ":")]
          ),
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("userManage.ATotalOf")) +
                " " +
                _vm._s(_vm.validateData.invalidCount) +
                " " +
                _vm._s(_vm.$t("userManage.items")) +
                " " +
                _vm._s(_vm.$t("userManage.dataHaveFailedVerification")) +
                " " +
                _vm._s(_vm.validateData.validCount) +
                " " +
                _vm._s(_vm.$t("userManage.accountsThatHavePassedVerification"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "failed-title" }, [
          _vm._v(
            _vm._s(_vm.$t("userManage.DataThatFailedVerification")) +
              "（" +
              _vm._s(_vm.validateData.invalidCount) +
              "）"
          ),
        ]),
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            { staticStyle: { flex: "1" } },
            [
              _c(
                "el-form",
                { attrs: { size: "small" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    _vm.$t("collectionCenter.compellation") +
                                    "/CPF",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchParam,
                                  callback: function ($$v) {
                                    _vm.searchParam = $$v
                                  },
                                  expression: "searchParam",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.searchInvalidData },
                                },
                                [_vm._v(_vm._s(_vm.$t("basicData.Search")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { flex: "1", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-bottom", size: "small" },
                  on: { click: _vm.downloadErr },
                },
                [_vm._v(_vm._s(_vm.$t("userManage.DownloadErrorDetails")))]
              ),
            ],
            1
          ),
        ]),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData, border: "", "max-height": "300" } },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("userManage.lineNumber"),
                prop: "rowNumber",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionCenter.compellation"),
                prop: "realName",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "CPF", prop: "cpf" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(_vm.formatCpfCnpj(scope.row.cpf))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionCenter.owningTransitCenter1"),
                prop: "hubName",
              },
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("home.position"), prop: "positionName" },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("userManage.NumberOfDaysTheAccountIsValid"),
                prop: "validDays",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("basicData.VerificationStatus"),
                prop: "valid",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      !scope.row.valid
                        ? _c(
                            "el-tag",
                            { attrs: { type: "danger", size: "mini" } },
                            [_vm._v(_vm._s(_vm.$t("basicData.failed")))]
                          )
                        : _vm._e(),
                      scope.row.valid
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "mini" } },
                            [_vm._v(_vm._s(_vm.$t("basicData.success")))]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("userManage.VerificationResult"),
                prop: "errorMessage",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticStyle: { color: "#cb272d" } }, [
                        _vm._v(_vm._s(scope.row.errorMessage)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { display: "flex", "margin-bottom": "20px" } },
          [
            _c("div", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(
                _vm._s(_vm.$t("userManage.ATotalOf")) +
                  " " +
                  _vm._s(_vm.validateData.invalidCount) +
                  " " +
                  _vm._s(_vm.$t("userManage.items")) +
                  _vm._s(_vm.$t("userManage.DataThatFailedVerification"))
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "confirm-sub" },
          [
            _c(
              "el-form",
              {
                ref: "submitParamRef",
                attrs: { model: _vm.submitParam, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "checked",
                      rules: {
                        required: true,
                        message: _vm.$t(
                          "userManage.PleaseCheckTheConfirmationBoxBeforeContinuingToCreateCnAccount"
                        ),
                        trigger: "change",
                      },
                    },
                  },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.submitParam.checked,
                          callback: function ($$v) {
                            _vm.$set(_vm.submitParam, "checked", $$v)
                          },
                          expression: "submitParam.checked",
                        },
                      },
                      [
                        _c("el-checkbox", { attrs: { label: "1" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("userManage.IHaveConfirmedThatOnlyThe")
                              ) +
                              " " +
                              _vm._s(_vm.validateData.validCount) +
                              " " +
                              _vm._s(
                                _vm.$t(
                                  "userManage.accountsThatHavePassedVerificationWill"
                                )
                              ) +
                              " " +
                              _vm._s(_vm.validateData.invalidCount) +
                              " " +
                              _vm._s(
                                _vm.$t("userManage.piecesOfDataThatFailed")
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "re-upload-container" }, [
      _c(
        "div",
        { staticStyle: { flex: "1", "font-size": "14px" } },
        [
          _c("el-button", { on: { click: _vm.reUploadExcel } }, [
            _vm._v(_vm._s(_vm.$t("userManage.ReUploadExcel"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { flex: "1", "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-bottom" },
              on: { click: _vm.downloadErr },
            },
            [_vm._v(_vm._s(_vm.$t("userManage.DownloadErrorDetails")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.uploadVerification },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("userManage.Create") +
                    _vm.validateData.validCount +
                    _vm.$t("userManage.accounts")
                )
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }